import styled from 'styled-components';
import { useColor } from '../../../partials/color';
import { LinkPartial } from '../../../partials/link';
import { colours, media, spacing } from '../../../stylings';

export const NotificationBarContainer = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0;

  @media ${media.greaterThan('lg')} {
    display: flex;
  }
`;
export const NotificationBarItem = styled.div<{ backgroundColor?: string }>`
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor || colours.BLACK};
  display: flex;
  height: 30px;
  justify-content: center;
  width: 100%;

  &:not(:only-child):not(:last-child) {
    margin: 0 ${spacing.XXXXS} 0 0;
  }

  & > * {
    padding: ${spacing.XXS};
  }

  @media ${media.greaterThan('lg')} {
    height: 40px;
  }
`;
export const NotificationBarLink = styled(LinkPartial)<{ $textColor: string; $defaultTextColor: string }>`
  ${({ $textColor, $defaultTextColor }) => useColor($textColor, $defaultTextColor)}
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0 5px;
  text-decoration-line: underline;
  text-decoration-thickness: 0.5px;
  text-underline-offset: 1.5px;

  & > p {
    margin: ${spacing.XXXXS} 0;
  }
`;
